import { Microphone } from 'tabler-icons-react';
import {
	SidebarStoryDetails,
	StoryAccordionTitle,
	UserStoryDescription
} from 'Elements';
import styles from 'partials/story-descriptions.module.scss';
import boxStyle from 'partials/story-box.module.scss';

export const StoryDescriptions = ({
	story,
	productions,
	isOpen,
	onBack,
	type
}) => {
	const getPersonName = (person) => {
		return `${person.f_name} ${person.l_name}`;
	};

	return (
		<SidebarStoryDetails
			story={story}
			type={type}
			isOpen={isOpen}
			onBack={onBack}>
			<div className={boxStyle.box}>
				<StoryAccordionTitle
					isOpen
					title={getPersonName(story?.persons[0])}
					icon={Microphone}
					hasExpand={false}
				/>
				<div
					className={styles.text}
					dangerouslySetInnerHTML={{
						__html: story?.description
					}}
				/>
				{productions?.map((story) => {
					return (
						<UserStoryDescription key={story.id} story={story} />
					);
				})}
			</div>
		</SidebarStoryDetails>
	);
};
